import { endOfDay, isBefore } from 'date-fns';

import { TaskItem } from '../../../core';
import { ViewTaskItem } from '../model/view-task-item.model';

// TODO revise. do mapping in api???
// see Microsoft.Graph.Models.Importance
export const IMPORTANCE_NORMAL = 'Normal';
export const IMPORTANCE_HIGH = 'High';

// TODO revise. do mapping in api???
// see Microsoft.Graph.Models.TaskStatus
export const STATUS_NOT_STARTED = 'NotStarted';
export const STATUS_COMPLETED = 'Completed';

export function viewTaskItemTransformer(tasks: TaskItem[]): ViewTaskItem[] {
    return tasks.map<ViewTaskItem>((e) => ({
        ...e,
        important:
            e.importance?.toLowerCase() === IMPORTANCE_HIGH.toLowerCase(),
        completed: e.status?.toLowerCase() === STATUS_COMPLETED.toLowerCase(),
        overdue:
            isBefore(endOfDay(e.dueDateTime), endOfDay(new Date())) &&
            e.status?.toLowerCase() !== STATUS_COMPLETED,
        editing: false,
    }));
}
